export const ERROR = {
    message: 'We’re unable to track your payment right now.',
};
